import { SecondaryPageLink } from '@/PageManager'
import { generateBech32IdFromATag, tagNameEquals } from '@/lib/tag'
import { cn } from '@/lib/utils'
import { Event } from '@nostr/tools/wasm'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

export default function GeocacheVerification({
  event,
  className
}: {
  event: Event
  className?: string
}) {
  const { t } = useTranslation()
  const aTag = useMemo(() => event.tags.find(tagNameEquals('a')), [event])
  const [finderHex, cacheNaddrRaw] = aTag ? aTag[1].split(':') : []
  const cacheNaddr = useMemo(() => {
    if (!cacheNaddrRaw) return undefined
    try {
      const [kind, pubkey, ...rest] = cacheNaddrRaw.split(':')
      if (kind && pubkey) {
        return generateBech32IdFromATag(['a', `${kind}:${pubkey}:${rest.join(':')}`])
      }
    } catch {
      // not a valid a-tag coordinate; fall back to raw value
    }
    return cacheNaddrRaw
  }, [cacheNaddrRaw])

  return (
    <div className={cn('space-y-2', className)}>
      <div className="font-medium">{t('Geocache verification')}</div>
      {event.content && <div className="text-sm text-muted-foreground">{event.content}</div>}
      <div className="space-y-1 text-sm text-muted-foreground">
        {finderHex && (
          <div>
            <span className="font-medium text-foreground">{t('Finder')}: </span>
            <span className="font-mono">{finderHex.slice(0, 16)}…</span>
          </div>
        )}
        {cacheNaddr && (
          <div>
            <span className="font-medium text-foreground">{t('Cache')}: </span>
            <SecondaryPageLink
              to={`/${cacheNaddr}`}
              className="text-primary hover:underline"
              onClick={(e) => e.stopPropagation()}
            >
              {cacheNaddr}
            </SecondaryPageLink>
          </div>
        )}
      </div>
    </div>
  )
}
